export default __webpack_public_path__ + "static/media/loading-1.066c9d2f.jpeg";